import React, { Fragment, useContext } from "react";
import { HamburgerContext } from "../../context/HamburgerContextProvider";
import MobileAbout from "../../parts/DropDown/MobileAbout/MobileAbout";
import Footer from "../../parts/Footer/Footer";
import NavbarContainer from "../../parts/Navbar/NavbarContainer";
import BuyAndSell from "../Home/BuyAndSell/BuyAndSell";
import AboutUsContent from "./AboutUsContent/AboutUsContent";
import BackedAdvised from "./BackedAdvised/BackedAdvised";
import JoinToday from "./JoinToday/JoinToday";
import LeaderShip from "./LeaderShip/LeaderShip";
import OurNetwork from "./OurNetwork/OurNetwork";
import { DownloadContext } from "../../context/DownloadContextProvider";
import RegistrationForm from "../Home/PopUpWindow/RegistrationForm/RegistrationForm";
import { Helmet } from "react-helmet";
function AboutUsPage() {
  const { showMediaIcons } = useContext(HamburgerContext);
  const { showPopUp } = useContext(DownloadContext);
  return (
    <Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>No. 1 Driver Service: Hire Professional Drivers Online.</title>
        <meta
          name="description"
          content="Hire professional car drivers for local and outstation drives. Services available 24x7 on-demand. Download the app to book now and explore many car services on your fingertips such as car wash, car servicing, insurance renewal, FASTag recharge & much more... Get rewarded for every transaction."
        />
        <meta
          name="keywords"
          content="car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune car driver services, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune for hire, car driver services in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers for rent in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver service in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver for hire in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver agency Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune for rent, driver agency in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, car driver service Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune car drivers services, hire a car driver in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, hire car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune, book car drivers in Ahmedabad, Bangalore, Chennai, Delhi NCR, Hyderabad, Kolkata, Mumbai & Pune"
        />
      </Helmet>
      <NavbarContainer />
      <div
        style={{ display: showMediaIcons ? "" : "none" }}
        className="MobileView_Option"
      >
        <MobileAbout />
      </div>
      <AboutUsContent />
      <LeaderShip />
      <BackedAdvised />
      <OurNetwork />
      <JoinToday />
      <BuyAndSell />
      <Footer />
      {showPopUp ? <div className="overlay" /> : null}
      {showPopUp ? <RegistrationForm className="form_number" /> : null}
    </Fragment>
  );
}

export default AboutUsPage;
